/**
 * Sits just above SMALL_MODAL's overlay (999). Use it for portaled popovers
 * (e.g. the date-picker dropdown) rendered from inside a modal, so they layer
 * above the modal instead of behind it.
 */
export const ABOVE_MODAL_Z_INDEX = 1000

export const SMALL_MODAL = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.80)',
    overflowY: 'overlay',
    zIndex: 999,
    width: '100vw',
  },
  content: {
    position: 'absolute',
    top: '50%',
    right: 'unset',
    left: '50%',
    bottom: 'unset',
    transform: 'translate(-50%, -50%)',
    border: 'none',
  },
}
